module.exports = __webpack_public_path__ + "img/step27_a_stand_power_remove_stacket_pocket_slot_it.91b667ac.png";